// extracted by mini-css-extract-plugin
export default {"tooltip":"FieldBold_tooltip__UGFtk","values":"FieldBold_values__DTvtl","children":"FieldBold_children__qHhNm","className":"FieldBold_className__+JP08"};